import React from 'react';
import {
  Box,
  Divider,
  Grid,
  Icon,
  Icons,
  List,
  ListItem,
  ListItemText,
  Radio,
  Stack,
  Typography,
} from '@nextiva/next-ui-components';
import { CardPackageProps } from 'interface/WizardV3';
import {
  CardContentStyled,
  CardStyled,
  LabelStyled,
} from './RequestWebsiteForm.styled';

const dataTestId = 'PlatformAdminUI-Messaging-RequestWebsiteForm-PriceCard';
export const PriceCard = ({
  card,
  isSelected,
  isMonthly,
}: CardPackageProps) => {
  const { title, subtitle, price, description, value } = card;
  const isPro = title === 'Pro';

  return (
    <CardStyled checked={isSelected} data-testid={dataTestId}>
      <CardContentStyled>
        <Stack spacing={2} alignItems="center" justifyContent="center">
          <Grid
            container
            direction="row"
            spacing={0}
            justifyContent="space-between"
            columns={24}
          >
            <Grid item xs={2}>
              <Radio
                checkedIcon={
                  <Icon icon={Icons.checkCircleSolid} color="primary" />
                }
                checked={isSelected}
                data-testid={`${dataTestId}-Radio`}
                value={value}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography
                data-testid={`${dataTestId}-Title`}
                variant="body1"
                fontWeight={800}
                component="div"
              >
                {title}{' '}
                {isPro && (
                  <LabelStyled type="business">Most popular</LabelStyled>
                )}
              </Typography>
            </Grid>
            <Grid item xs={9} textAlign="right">
              <Typography variant="h6" fontWeight={800}>
                {!isMonthly && (
                  <Typography
                    variant="subtitle2"
                    fontWeight={500}
                    color="#ACAEB8"
                    sx={{ textDecoration: 'line-through' }}
                    data-testid={`${dataTestId}-Price`}
                    component="span"
                  >
                    {price.monthly}
                    {'  '}
                  </Typography>
                )}
                {isMonthly ? price.monthly : price.yearly}{' '}
                <Typography variant="caption">/mo</Typography>
              </Typography>
            </Grid>
            <Grid item xs={24} sx={{ marginLeft: '27px' }}>
              <Typography
                data-testid={`${dataTestId}-Subtitle`}
                variant="caption"
                color="#A0A2AD"
                component="div"
              >
                {subtitle}
              </Typography>
            </Grid>
            <Grid item xs={24} marginTop={1}>
              <Divider />
            </Grid>
            <Grid item xs={24} marginTop={1}>
              <List sx={{ padding: '0px' }}>
                {description.map((descItem) => (
                  <ListItem key={descItem} disablePadding>
                    <Box display="inline-flex" alignItems="center">
                      <Icon
                        icon={Icons.check}
                        size={16}
                        sx={{ color: '#7A7D8C', marginRight: '8px' }}
                      />
                      <ListItemText
                        primary={descItem}
                        primaryTypographyProps={{
                          variant: 'caption',
                          color: '#0B1029',
                        }}
                      />
                    </Box>
                  </ListItem>
                ))}
              </List>
            </Grid>
          </Grid>
        </Stack>
      </CardContentStyled>
    </CardStyled>
  );
};
